module.exports = __webpack_public_path__ + "img/drink.c9a9e2f5.svg";